import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeOidcLogin } from '../utils/oidcAuth';
import './Login.css';

export function OidcCallback() {
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    completeOidcLogin()
      .then(() => {
        if (isMounted) navigate('/dashboards/general', { replace: true });
      })
      .catch((err) => {
        if (isMounted) setError(err?.message || 'SSO login could not be completed.');
      });

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  return (
    <div className="login-callback">
      <div className="login-callback-card">
        <h1>SSO Login</h1>
        {error ? <div className="login-error">{error}</div> : <p>Completing login...</p>}
      </div>
    </div>
  );
}
